export default function SuitableFor() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            向いている人
          </h2>
          <p className="text-gray-600">
            あなたのライフスタイルに合わせて最適なカードを選びましょう
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* 大手ECモール系カード向き */}
          <div className="bg-gradient-to-br from-rose-50 to-white border-2 border-rose-200 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-14 h-14 bg-rose-600 rounded-2xl flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">大手ECモール系カードが向いている人</h3>
            </div>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-rose-100">
                <div className="w-8 h-8 bg-rose-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-rose-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">ECモールをよく利用する</div>
                  <div className="text-sm text-gray-600">経済圏でポイントを効率的に貯めたい方</div>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-rose-100">
                <div className="w-8 h-8 bg-rose-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-rose-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">基本還元率を重視</div>
                  <div className="text-sm text-gray-600">どこで使っても1%還元が欲しい方</div>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-rose-100">
                <div className="w-8 h-8 bg-rose-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-rose-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">審査が不安</div>
                  <div className="text-sm text-gray-600">比較的審査が通りやすいカードを探している方</div>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-rose-100">
                <div className="w-8 h-8 bg-rose-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-rose-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">関連サービスを複数利用</div>
                  <div className="text-sm text-gray-600">モバイル、銀行などの関連サービスを使っている方</div>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-rose-100">
                <div className="w-8 h-8 bg-rose-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-rose-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">ポイントの使い道が豊富</div>
                  <div className="text-sm text-gray-600">ポイントを日常的に使いたい方</div>
                </div>
              </div>
            </div>

            <a
              href="/rakuten"
              className="block w-full bg-rose-600 hover:bg-rose-700 text-white font-bold py-4 rounded-xl text-center transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
            >
              大手ECモール系カードの詳細を見る
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          {/* 三井住友カード向き */}
          <div className="bg-gradient-to-br from-teal-50 to-white border-2 border-teal-200 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-14 h-14 bg-teal-600 rounded-2xl flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">三井住友カードが向いている人</h3>
            </div>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-teal-100">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">コンビニをよく利用する</div>
                  <div className="text-sm text-gray-600">セブン-イレブン、ローソンで最大7%還元</div>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-teal-100">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">即日発行したい</div>
                  <div className="text-sm text-gray-600">最短即日でカードを手に入れたい方</div>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-teal-100">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">セキュリティ重視</div>
                  <div className="text-sm text-gray-600">ナンバーレスで安心して使いたい方</div>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-teal-100">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">ブランド力を重視</div>
                  <div className="text-sm text-gray-600">信頼できる老舗ブランドを選びたい方</div>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-white rounded-xl p-4 border border-teal-100">
                <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">マクドナルドをよく利用</div>
                  <div className="text-sm text-gray-600">ファストフードで高還元を受けたい方</div>
                </div>
              </div>
            </div>

            <a
              href="/mitsui"
              className="block w-full bg-teal-600 hover:bg-teal-700 text-white font-bold py-4 rounded-xl text-center transition-all duration-300 shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
            >
              三井住友カードの詳細を見る
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
